import {
  GET_ALL_ADDRESS,
  GET_ADDRESS
} from 'src/store/mutation-types'
export default {
  [GET_ALL_ADDRESS] (state, cities) {
    state.cities = cities
  },
  [GET_ADDRESS] (state, city) {
    state.city = city
  }
}



// WEBPACK FOOTER //
// ./src/components/address/store/mutations.js